// Utils.js
import { Box } from "grommet";
import { useEffect } from "react";

export function generateVineUID(id, row, column, year){
    // console.log(id + '-' + row +'-' + column +'-' + year);
    return id + '-' + row +'-' + column + '-' + year;
};

// some months and days of the month are single-digit and others double-digit
// function adds a leading 0
export function pad(n) {
    return n < 10 ? '0'+n : n;
};

export const convertDateToDisplayformat = (date) => {
    // console.log(' date in convertDateToDisplayformat >> ', date);
    if (date === null || date === undefined)
        return '';

    let newDate = new Date(date);
    // console.log('newDate  >> ', newDate);
    // newDate = newDate.toISOString().slice(0, 19).replace('T', ' ');
    // setDisplayDate(newDate.substring(0, newDate.indexOf(' ')));

    const currentDayOfMonth = newDate.getDate();
    const currentMonth = newDate.getMonth(); // Be careful! January is 0, not 1
    const currentYear = newDate.getFullYear();

    return (pad(currentDayOfMonth) + "-" + pad(currentMonth + 1) + "-" + currentYear);    // "27-11-2020"            
};

export const formatTime = (date) => {
    if (date === null || date === undefined)
    return '';

    let currentDate = new Date(date);

    const hours = currentDate.getHours().toString().padStart(2, '0');
    const minutes = currentDate.getMinutes().toString().padStart(2, '0');
    const seconds = currentDate.getSeconds().toString().padStart(2, '0');
    return `${hours}:${minutes}:${seconds}`;
};

export const convertDateToSQLDateformat = (date) => {
    // console.log(' date in convertDateToSQLDateformat >> ', date);
    let newDate = date === undefined ? null : new Date(date); 

    // console.log('newDate  >> ', newDate);
    if (newDate !== null) {
        let sqlDate = newDate.toISOString().slice(0, 19).replace('T', ' ');
        newDate = sqlDate.substring(0, sqlDate.indexOf(' ')); // date format: 'yyyy-mm-dd', for example: '2023-05-24
    }
    return newDate;
};


// The date picker returns the current date minus one day, 
// this is due to your browser or server's time zone offset
// To solve this problem, you can either adjust the date 
// and time to the correct time zone before calling the toISOString() method
export const correctTimeZone = (date) => {   
    if (date === null || date === undefined)
        return '';    
    
    let newDate = new Date(date); 
    
    if (newDate !== null) {
    //    const newDate = new Date(isoDateString); // create a new Date object
        const timeZoneOffset = newDate.getTimezoneOffset() * 60000; // get the time zone offset in milliseconds
        const adjustedDate = new Date(newDate.getTime() - timeZoneOffset); // subtract the time zone offset from the date

        newDate = adjustedDate.toISOString(); // convert the adjusted date to an ISO string   
    }
    return newDate;
};

// Converting the string to a Date object 
// and then extracting the year from it. 
export const extractYearFromDateISOString = (dateISOString) => {
    const date = new Date(dateISOString);
    return date.getFullYear();
};

// Generating a UUID for syncId
export const generateSyncId = () => {
    // 🚀 Replace this with your preferred UUID generation library
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
        const r = (Math.random() * 16) | 0,
            v = c === 'x' ? r : (r & 0x3) | 0x8;
        return v.toString(16);
    });
};


export const  isValidUIDFormat = (value) => {
    const uuidRegex = /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/;
    return uuidRegex.test(value);
};

export const isValidYearString = (yearField, mandatory, yearFieldName = 'year') => {
    let result = { res: true, msg: '' };

    if ( yearField === null || yearField === "") {
        if (mandatory) {
            result.msg = "The " + yearFieldName + " is a mandatory field.";
            result.res = false;
        }        
        return result;              
    }

    // Regular expression pattern ensures the string is exactly 4 digits long, 
    // starts with a non-zero digit.
    // It also implicitly ensures there are no 'e' characters since it only allows digits.
    // const pattern = /^[1-9]\d{3}$/;
    const pattern = /^[1-9][0-9]{3}$/;

    if (!pattern.test(yearField)) {
        result.msg = "The " + yearFieldName + " must be a positive 4-digit integer.";
        result.res = false;
        return result;        
    }

    return result;
};

export function nearestInteger(number) {
    const cutoff = 0.5;
  
    if (number >= cutoff) {
        return Math.ceil(number);
    } else {
        return Math.floor(number);
    }
};

export function updateStateHandler(stateFunction, fieldName, value) {
    // console.log('In updateStateHandler f-n new value >> ' + value + ' in field >> ' + fieldName);
    stateFunction(prevState => ({
        ...prevState,
        [fieldName]: value,
        // set 'UpdatedAt' to the current date only if the field that was edited 
        // is one of the following:"Notes", "FreeImgText", "Pruning"
        ...((fieldName === "FreeImgText")  && { UpdatedAt: new Date() }), 
    }));   
};


/**
 * Updates the state of an array by mapping through its elements.
 * 
 * @param {Function} stateFunction - The state setter function (e.g., setState).
 * @param {string} fieldName - The field name in the objects within the array to be updated.
 * @param {*} value - The new value to assign to the specified field.
 * @param {Function} [predicate] - Optional. A function that determines which elements to update.
 *                                  Should return `true` for elements to update.
 *
 * If last param not provided:
 *      The function maps over each element (el) in the previous state (prevState) 
 *  and sets the value of the specified field (fieldName) to the new value (value). 
 *  However, the function returns the updated el object.
 */
export function updateArrStateHandler(stateFunction, fieldName, value, predicate) {
    stateFunction(prevState =>
        prevState.map(el =>
            predicate && typeof predicate === 'function' 
                ? (predicate(el) ? { ...el, [fieldName]: value } : el) // Update only matching elements
                : { ...el, [fieldName]: value } // Update all elements if no predicate
        )
    );
}


export function updateStateRGBHandler(stateFunction, fieldName, value, index){
    // console.log('updateStateRGBHandler f-n: value:'+value +'. index:'+index);
    stateFunction(prevState => ({
        ...prevState,
        [fieldName]:{value: value, index: index}       
    }));
};

// returns all the values from the given key.
export const pluck = (arr, key) => arr.map(i => i[key]);

export const plantStatus = [
    { 1: 'excellent'},
    { 2: 'reevaluete'},
    { 3: 'disqualified'},   
];

export const sheetStatus = [
    { 3: 'In Progress'},
    { 4: 'Completed'},
    { 5: 'Submitted'},
    { 6: 'Deleted'},
    { 7: 'Variety'},   
];

export const maxRowsOnField = 99;
// export const maxVinesOnRow = 120;
export const maxVinesOnStation = 10; // vines in row, I use when I draw field in StationsField component

export function getKeyByValue (array, value) {
    // get object by value from array
    const sheet = array.find(item => {return Object.keys(item).find(key => item[key] === value)});
    return Number(Object.keys(sheet)[0]);
};

export const DrawArrayByRows = (array, columnsInRow, key, drawItem) => {
    if (array.length === 0)
        return;

    let all = []; // arry of the all elements
    let row = []; // array of elements in the one row
    for (let i = 0; i < array.length; i++) {
        row.push(array[i]); 
        if ((i+1) % columnsInRow === 0)
        {
            // console.log('row >> ', row);
            all.push(DrawRow(row, drawItem, `${key}-${i}`)); // unique key for each row
            row = [];
        }  
    }
    // add the last elements in the array to draw
    all.push(DrawRow(row, drawItem, `${key}-last`)); // ensure last row also has a unique key

    return(all);
};


export const DrawRow = (arr, drawItem, key) => {
    if (arr.length === 0)
        return;

    // console.log('arr in DrawRow >> ', arr);
    const row = [];
    row.push( 
        <Box direction="row" key={key} align="center" justify="between">                
        {arr.map((item, index) => 
            drawItem(item, `${key}-${index}`)  // unique key for each item in the row 
        )}   
        </Box> 
    );
    return(row);
};

export const includesObj = (arr, key, value) => {
    let isContained = false;

    for (const obj of arr) {
        if (obj[key] === value) {
            isContained = true;
            //console.log(obj); 
            break;
        }
    }
    // console.log('isContained >> ', isContained);
    return isContained;
};

//  function gets string of numbers separated with comma and 
// returns array of integers without repeating of numbers
export const uniqueNumbersToString = (inputString) => {
    // Split the input string by commas
    const inputArray = inputString.split(',');
  
    // Convert each element of the input array to integers and filter out duplicates
    const uniqueNumbersArray = inputArray
      .map(Number)
      .filter((number, index, self) => self.indexOf(number) === index);
  
    // Join the unique numbers array into a new string separated by commas
    const uniqueNumbersString = uniqueNumbersArray.join(',');
  
    return uniqueNumbersString;
};


// calculates height value. 
// parameter vh, representing a percentage of the viewport height.
// If the computed height in pixels is less than 32 pixels, 
// it returns a fixed height of '26px'. 
// Otherwise, it returns the height as a percentage string (e.g., '5vh').

export const calculateHeight = (vh) => {
    const heightPx = (window.innerHeight * vh) / 100;
    return heightPx < 32 ? '26px' : `${vh}vh`;
};

// function for opening any modal window
export const usePopupFocus = (isOpen, elementId) => {
    useEffect(() => {
        if (isOpen) {
            const observer = new MutationObserver(() => {
                document.querySelectorAll("[aria-hidden='true']").forEach(el => {
                    el.removeAttribute("aria-hidden");
                });

                const safeElement = document.getElementById(elementId);
                if (safeElement) {
                    safeElement.focus();
                    observer.disconnect(); // Stop watching once we focus
                }
            });

            observer.observe(document.body, { childList: true, subtree: true });
            return () => observer.disconnect();
        }
    }, [isOpen, elementId]);
};

export function getDBURL() {
    const env = process.env.REACT_APP_ENV;
    // console.log(" 👇️ process.env.REACT_APP_ENV in Utils  >>  ", env);

    switch (env) {
        case 'development':
            // tell the client where the server runs on localhost
            return "http://localhost:3001/api";
        case 'production':
            // tell the client where the server runs in production
            return "https://vines.agri.gov.il/api";
        case 'local_dev':
            // tell the client where the server runs on my computer
            return "http://localhost:3001/api";
        case 'cloud_dev':
            // tell the client where the server runs on cloud
            return "https://vines.volcani.institute/api";
            // return "https://vines-995709994155.me-west1.run.app/api";
        default:
            // Optional: handle unexpected environments
            throw new Error(`REACT_APP_ENV '${env}' is not set to a recognized value.`);
    }
};
